module.exports = __webpack_public_path__ + "static/media/fichaTecnicaKalenday.ab273d06.pdf";